import { Spinner } from "../Components/Loding/SpinnerPadrao";

interface IOrSpinnerProps {
    loading: boolean;
    loadingSize?: "lg" | "md" | "sm" | "xl";
}

export default function orSpinner<TComponentProps>(
    WrapperComponent: React.ComponentType<TComponentProps>
) {
    function OrSpinner(props: IOrSpinnerProps & TComponentProps) {
        const { loading, loadingSize, ...componentProps } = props;

        const finalProps = {
            ...componentProps,
        } as Exclude<IOrSpinnerProps & TComponentProps, IOrSpinnerProps>;

        return loading ? (
            <Spinner size={loadingSize} />
        ) : (
            <WrapperComponent {...finalProps} />
        );
    }

    return OrSpinner;
}
